export default {
  selectedMoveButtonStyles: {
    marginLeft: "auto",
    background: "white",
    borderRadius: "50%",
    cursor: "pointer",
  },

  selectedMoveBackgroundStyles: {
    borderRadius: "15%",
    padding: "0.5rem",
    margin: "0.5rem 0 0 0.5rem",
    minWidth: "6rem",
    height: "1rem",
    display: "flex",
    alignItems: "center",
  },

  selectedMoveStyles: {
    fontFamily: "Roboto",
    margin: "0.5rem 0.5rem 0.5rem",
    color: "white",
  },
};
